import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { setLoginPiKeys } from "../../../../reduxStore/actions/main";
import { pageNames } from "../../../../reduxStore/reducers/main";
import { BottomButtonContainer } from "../../../elements/wrapper/bottomButton.wrapper";
import Login from "./Login.component";
import Instruction from "./Instruction.component";
import IntroImage from "../../introImage.component";
import image from "./CA-Signet-Dark-Background.svg";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import { nativeStorageInterface } from "../../../..";

export const passStatus = {
  waiting: "waiting",
  correct: "correct",
  wrong: "false",
  nothing: "nothing",
};
export const catchupKey =
  "CU-HH-Z9pL5bVod3V70AJjRa4guzUJWehf3JWqAw85qHB8CZZPlzeC80";
function Welcome(props) {
  const [welcomeScreen, setWelcomScreen] = useState("hello");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [userPassedStatus, setUserPassedStatus] = useState(passStatus.nothing);
  const history = useHistory();

  const handleStoredCredentials = () => {
    var demoCredentials = localStorage.getItem("demoLogin");
    if (demoCredentials == null) return;

    var demoCredentialsParsed = JSON.parse(demoCredentials);
    setName(demoCredentialsParsed.name);
    setPassword(demoCredentialsParsed.password);
  };

  const handleSubmit = () => {
    setUserPassedStatus(passStatus.waiting);
    // TODO: send to server and receive answer in form of loginPiKeys
    setTimeout(() => {
      var demoCredentials = { name: name, password: password };
      localStorage.setItem("demoLogin", JSON.stringify(demoCredentials));

      // TODO: hardcoded wenn mainz, dann mainz
      if (name === "UKM" && password === "HHMainz2022") {
        props.setLoginPiKeys([
          {
            key: "UKM-uq0rr9IYnEam2B5h0eKFzaj1azYXvhpJrzA6THZRDv0Cjs",
            name: "UKM",
          },
        ]);
        setUserPassedStatus(passStatus.correct);
        history.push(`/${pageNames.intro}/${pageNames.choosePiKey}`);
      } else if (name === "Avaya" && password === "rZBwnX2J") {
        props.setLoginPiKeys([
          {
            key: "avaya-5RQmaQSJ7XFWgGyPxAe0qdWhao4iFkjDOSu5CmEazypl",
            name: "Avaya",
          },
        ]);
        setUserPassedStatus(passStatus.correct);
        history.push(`/${pageNames.intro}/${pageNames.choosePiKey}`);
      } else if (name === "FHID" && password === "JGR5UF") {
        props.setLoginPiKeys([
          {
            key: "FHID-mrUnwCogLThZd5Wo56iCpUaoq8fvGXrQSSNcRs43jWELo",
            name: "FHID",
          },
        ]);
        setUserPassedStatus(passStatus.correct);
        history.push(`/${pageNames.intro}/${pageNames.choosePiKey}`);
      } else if (name === "KHBR" && password === "Braunau2023") {
        props.setLoginPiKeys([
          {
            key: "KHBR-hXf0ATzBt5SCYTdNnY6c6Tm9z5AxhYMrpyKygpaZ3gbLo",
            name: "KHBR",
          },
        ]);
        setUserPassedStatus(passStatus.correct);
        history.push(`/${pageNames.intro}/${pageNames.choosePiKey}`);
      } else if (name === "HDZ" && password === "hdztest") {
        props.setLoginPiKeys([
          {
            key: "HDZ-NRW-iXgodcIUbWP1cxKDeXMwKj2OuATSy1mbiVn7ISGXbw",
            name: "HDZ-NRW",
          },
        ]);
        setUserPassedStatus(passStatus.correct);
        history.push(`/${pageNames.intro}/${pageNames.choosePiKey}`);
      } else {
        setUserPassedStatus(passStatus.wrong);
      }
    }, 500);
  };
  const continueWithoutLogin = () => {
    sendWithCatchup();
  };
  const sendWithCatchup = () => {
    // TODO: push catchup key
    nativeStorageInterface.set("piKey", catchupKey);
    props.setPiKeyState(catchupKey);
    history.push(
      `/${pageNames.intro}/${pageNames.selectLanguage}${getQueryParams()}`
    );
  };
  const sendToLogin = () => {
    setWelcomScreen("password");
  };

  const getButtons = () => {
    if (welcomeScreen === "password") {
      return [
        <div
          role="button"
          key={1}
          onClick={handleSubmit}
          className="d-flex justify-content-center pl-3 pr-3 pb-2 pt-2 corporateButton corporateButton--primary mb-3"
        >
          <FormattedMessage id="intro.login.submit" />
        </div>,
        <div
          role="button"
          key={0}
          onClick={continueWithoutLogin}
          className="d-flex justify-content-center pl-3 pr-3 pb-2 pt-2 corporateButton corporateButton--secondary"
        >
          <FormattedMessage id="intro.welcomeScreen.next" />
        </div>,
      ];
    } else {
      return [
        <div
          role="button"
          key={3}
          onClick={sendToLogin}
          className="d-flex justify-content-center pl-3 pr-3 pb-2 pt-2 corporateButton corporateButton--primary mb-3"
        >
          <FormattedMessage id="intro.welcomeScreen.login" />
        </div>,
        <div
          role="button"
          key={2}
          onClick={sendWithCatchup}
          className="d-flex justify-content-center pl-3 pr-3 pb-2 pt-2 corporateButton corporateButton--secondary"
        >
          <FormattedMessage id="intro.welcomeScreen.next" />
        </div>,
      ];
    }
  };

  useEffect(handleStoredCredentials, []);

  return (
    <BottomButtonContainer
      className=" text-white d-flex flex-column align-items-center"
      buttonClassName="d-flex flex-column w-100 align-items-center"
    >
      <IntroImage fallbackImage={image} height="30%" />
      <div className="d-flex flex-column pl-3 pr-3 align-items-center p-3 text-white">
        {welcomeScreen === "hello" ? (
          <Instruction />
        ) : (
          <Login
            userPassedStatus={userPassedStatus}
            name={name}
            password={password}
            setName={setName}
            setPassword={setPassword}
          />
        )}
        <div className="d-flex flex-column align-items-center w-100 mt-5">
          {getButtons()}
        </div>
      </div>
    </BottomButtonContainer>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setLoginPiKeys: (loginPiKeys) => dispatch(setLoginPiKeys(loginPiKeys)),
});

export default withRouter(connect(null, mapDispatchToProps)(Welcome));
